import { z } from "zod";
export const ASSET_URL_MAX_LENGTH = 1024;
// 1. Define the reusable sub-schema
const AssetSchema = z.object({
    name: z.string().max(256).optional(),
    url: z.string()
        .max(ASSET_URL_MAX_LENGTH, "URL must be at most 200 characters")
        .refine((value) => !value.toLowerCase().startsWith("data:"), {
        message: "URL must not start with data:",
    }),
});
// 2. Define your keys as a constant tuple (exported for reuse)
export const ASSET_KEYS = [
    "darkBackground",
    "darkLogo",
    "lightBackground",
    "lightLogo",
];
// 3. Generate the Zod object dynamically
export const AppSettingsAssetsSchema = z.object(ASSET_KEYS.reduce((acc, key) => {
    acc[key] = AssetSchema;
    return acc;
}, {}));
/**
 * Storage limits of room file sharing. Server-owned: only the admin API may
 * change them; settings saves from the app keep the stored values.
 * `maxTotalBytes: 0` turns file sharing off for the instance.
 */
export const DEFAULT_FILE_SHARING_LIMITS = {
    maxFileBytes: 200 * 1024 * 1024,
    maxTotalBytes: 1024 * 1024 * 1024,
};
export const FileSharingLimitsSchema = z.object({
    maxFileBytes: z.number().int().nonnegative(),
    maxTotalBytes: z.number().int().nonnegative(),
});
export const AppSettingsSchema = z.object({
    title: z.string().max(256),
    developerMode: z.boolean().default(false),
    assets: AppSettingsAssetsSchema,
    colorMode: z.enum(["dark", "light"]),
    gateway: z.string().max(256),
    styles: z.array(z.object({
        id: z.string().max(256),
        dark: z.string().max(256),
        light: z.string().max(256),
    })),
    fileSharing: FileSharingLimitsSchema.default(() => ({
        ...DEFAULT_FILE_SHARING_LIMITS,
    })),
});
export const GenerateAppConfigRequestSchema = z.object({
    url: z.string().url().max(2048),
});
/** A suggestion is partial: missing branding fields leave the current editor value intact. */
export const GeneratedAppConfigSchema = z.object({
    title: z.string().optional(),
    colorMode: z.enum(["dark", "light"]).optional(),
    styles: z.array(z.object({ id: z.string(), dark: z.string(), light: z.string() })).optional(),
    assets: z.record(z.string(), z.string()).optional(),
}).passthrough();
